/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：539
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_295 from /* 295 */"./295"
import * as /* [auto-meaningful-name] */Lodash from /* 30 */"lodash"
import { memo, useCallback } from /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
import * as /* [auto-meaningful-name] */Src_shared_ui_components_index from /* 13 */"../../../../src/shared/ui/components/index"
import /* 640 */"./13/640"
var _a
_a = memo(function (e) {
  var /* [auto-meaningful-name] */e$onStep = e.onStep
  var /* [auto-meaningful-name] */e$max = e.max
  var /* [auto-meaningful-name] */e$min = e.min
  var /* [auto-meaningful-name] */e$defaultValue = e.defaultValue
  var /* [auto-meaningful-name] */e$disabled = e.disabled
  var /* [auto-meaningful-name] */e$label = e.label
  var f = Module_295.a(e, ["onStep", "max", "min", "defaultValue", "disabled", "label"])
  var h = Number(e$max) <= Number(e$defaultValue)
  var m = Number(e$min) >= Number(e$defaultValue)
  var g = Number(e$defaultValue)
  var _ = useCallback(function (e) {
    if (!h && Lodash.isFunction(e$onStep)) {
      e$onStep("".concat(g + 1), e, "up")
    }
  }, [h, e$onStep, g])
  var v = useCallback(function (e) {
    if (!m && Lodash.isFunction(e$onStep)) {
      e$onStep("".concat(g - 1), e, "down")
    }
  }, [m, e$onStep, g])
  return React1.createElement(Src_shared_ui_components_index.k, Object.assign({}, f, {
    className: Classnames1(f.className, "coco-number-input-wrapper"),
    defaultValue: e$defaultValue,
    min: e$min,
    max: e$max,
    disabled: e$disabled,
    after: React1.createElement(React1.Fragment, null, React1.createElement("div", {
      className: Classnames1("coco-number-input-label")
    }, React1.createElement("span", null, e$label)), React1.createElement("div", {
      className: "coco-number-input"
    }, React1.createElement("span", {
      className: h || e$disabled ? "disable" : "",
      onClick: _
    }, React1.createElement(Src_shared_ui_components_index.j, {
      type: "icon-up"
    })), React1.createElement("span", {
      className: m || e$disabled ? "disable" : "",
      onClick: v
    }, React1.createElement(Src_shared_ui_components_index.j, {
      type: "icon-down"
    }))))
  }))
})
export { _a as a }
export default _a
